import { getBuyNowCart } from '@/modules/buy-now/infrastructure/services/getBuyNowCart.queries';
import type { Cart } from '@/modules/cart/domain/Cart';
import { httpCartDtoToCart } from '@/modules/cart/infrastructure/mappers/httpCartDtoToCart';

export async function getBuyNowCartById(cartId: string): Promise<Cart> {
  const response = await getBuyNowCart(cartId);
  const cart = httpCartDtoToCart(response.data);
  return cart;
}
